import React from 'react';
import {
  IconButton,
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormLabel,
  TextField,
  Select,
  MenuItem,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import useStyles from './styles';

function ActionCreationPage() {
  const classes = useStyles();
  const { t } = useTranslation();

  const onCancel = () => {};

  const onSave = () => {};

  return (
    <div className={classes.root}>
      <IconButton
        aria-label="cancel"
        className={classes.cancelButton}
        onClick={onCancel}
      >
        <CloseIcon />
      </IconButton>
      <IconButton
        aria-label="save"
        className={classes.saveButton}
        onClick={onSave}
      >
        <CheckIcon />
      </IconButton>
      <Grid container spacing={0}>
        <Typography className={classes.title}>
          {t('action_details')}
          {' no '} {12345}
        </Typography>
      </Grid>
      <Accordion className={classes.accordion} defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
        >
          <Typography className={classes.heading}>
            {t('action_details_heading')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: 'block' }}>
          <div className={classes.description}>
            <span className={classes.asterisk}>*</span>
            {t('edit ticket description')}
          </div>
          <div className={classes.container}>
            <Grid container spacing={1} className={classes.gridMargin}>
              <Grid item xs={3}>
                <FormLabel className={classes.formLabel}>
                  {t('action_number')}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                <FormLabel className={classes.formLabel}>
                  {t('action_creation_date')}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                <FormLabel className={classes.formLabel}>
                  {t('creator')}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                <FormLabel className={classes.formLabel}>
                  {t('Wagon number')}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  value={123}
                />
              </Grid>
              <Grid item xs={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    InputProps={{ className: classes.input }}
                    disableToolbar
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                    margin="normal"
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  value="abc"
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  value={123}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} className={classes.gridMargin}>
              <Grid item xs={6}>
                <FormLabel className={classes.formLabel}>
                  {t('action_description')}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                <FormLabel className={classes.formLabel}>
                  {t('action_title')}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                <FormLabel className={classes.formLabel}>
                  {t('action_status')}
                </FormLabel>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  value="Action Description"
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  value="Action Title"
                />
              </Grid>
              <Grid item xs={3}>
                <FormLabel className={classes.formControl}>
                  <Select
                    variant="outlined"
                    className={classes.select}
                    MenuProps={{ classes: { paper: classes.dropdownStyle } }}
                  >
                    <MenuItem>Action Open</MenuItem>
                    <MenuItem>Action Close</MenuItem>
                  </Select>
                </FormLabel>
              </Grid>
            </Grid>
            <Grid container spacing={1} className={classes.gridMargin}>
              <Grid item xs={3}>
                <FormLabel className={classes.formLabel}>
                  {t('due_date')}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                <FormLabel className={classes.formLabel}>
                  {t('Product type')}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                <FormLabel className={classes.formLabel}>
                  {t('Business unit')}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                <FormLabel className={classes.formLabel}>
                  {t('Wagon status')}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    InputProps={{ className: classes.input }}
                    disableToolbar
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                    margin="normal"
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  value="product type"
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  value="business unit"
                />
              </Grid>
              <Grid item xs={3}>
                <FormLabel className={classes.formControl}>
                  <Select
                    variant="outlined"
                    className={classes.select}
                    MenuProps={{ classes: { paper: classes.dropdownStyle } }}
                  >
                    <MenuItem>Wagon Open</MenuItem>
                    <MenuItem>Wagon Close</MenuItem>
                  </Select>
                </FormLabel>
              </Grid>
            </Grid>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
export default ActionCreationPage;
